import { render, staticRenderFns } from "./MineDetail.vue?vue&type=template&id=2a1ff7f8&scoped=true"
import script from "./MineDetail.vue?vue&type=script&lang=js"
export * from "./MineDetail.vue?vue&type=script&lang=js"
import style0 from "./MineDetail.vue?vue&type=style&index=0&id=2a1ff7f8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_cache-loader@4.1.0_webpack@4.47.0__css-load_56918b6c9ce26bff301cc579b29c5ca5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1ff7f8",
  null
  
)

export default component.exports